import { render, staticRenderFns } from "./Paid.vue?vue&type=template&id=573fbfeb"
import script from "./Paid.vue?vue&type=script&lang=js"
export * from "./Paid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports